import { GAME_ID, REDUX_ACTIONS, SCREENS } from '../../data/constants';
import { getLevelCount } from '../../content/curriculum';

const initialState = {
  // Props synchronized with server
  highestLevelEarned: 0,
  hasCompletedOnboarding: false,
  levelsMastered: [],
  // saved character for current user
  character: null,
  levelToStartAfterCharacterSelection: 0,
  isOnboardingFromHelpAfterCharacterSelection: false,
};

const gameProgressReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.CHANGE_SCREEN: {
      if (payload.screen === SCREENS.CHARACTER_SELECTION) {
        const { levelToStartAfterCharacterSelection, isOnboardingFromHelpAfterCharacterSelection } = payload;
        return {
          ...state,
          levelToStartAfterCharacterSelection,
          isOnboardingFromHelpAfterCharacterSelection,
        };
      }
      return state;
    }
    case REDUX_ACTIONS.INITIALIZE_GAME:
      return {
        ...state,
        levelsMastered: Array(getLevelCount()).fill(false),
      };

    case REDUX_ACTIONS.LEVEL_MASTERED: {
      const levelCount = getLevelCount();
      const levelsMastered = [...state.levelsMastered];
      const levelIndex = payload;
      const highestLevelEarned = levelIndex + 1 < levelCount - 1 ?
        levelIndex + 1 :
        levelCount - 1;

      levelsMastered[levelIndex] = true;
      return {
        ...state,
        levelsMastered,
        highestLevelEarned,
      };
    }

    case REDUX_ACTIONS.SELECT_CHARACTER: {
      const characterId = payload;
      if (state.character === null) {
        return {
          ...state,
          character: characterId,
        };
      }

      return state;
    }

    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        hasCompletedOnboarding: true,
      };

    default:
      return state;
  }
};

export default gameProgressReducer;
